import React from 'react';

import * as IconFi from 'react-icons/fi';

const NoContent = props => {

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div className="d-flex flex-column align-items-center text-center">
            <IconFi.FiInfo size={48} className="sw-1 text-white text-opacity-38 mb-3"/>
            <span className="text-white text-opacity-60 fs-5">{props.text}</span>
        </div>
    )
}

export default NoContent;